module.exports = __webpack_public_path__ + "img/btpt-membership.3a0d0d4e.png";